<template>
  <div class="row page-wrapper">
    <div class="col-12">
      <div class="row page-header">
        <div class="col-12 col-md-6 col-xl-8">
          <h3>Kunden</h3>
        </div>
        <div class="col-12 col-md-6 col-xl-4">
          <b-button to="/add-company" class="btn-primary btn-new-company float-right">
            + Neue Kunde erstellen
          </b-button>
        </div>
      </div>
      <div class="row table-wrapper">
        <!-- <div class="col-12">
          <data-table
            ref="table"
            v-model="table"
            id="company-table"
            :get-page="getPage"
            :per-page="1000"
            :selectable-rows="true"
            :has-details-row="false"
            :busy="isLoading"
            :responsive="true"
          >
            <template #head(name)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.name" input-type="text" />
            </template>
            <template #head(companyToken)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.companyToken" input-type="text" />
            </template>
            <template v-slot:cell(createdAt)="data">
              {{ data.value | formatDateTime }}
            </template>
            <template v-slot:cell(actions)="data">
              <div class="btn-actions-container">
                <img svg-inline class="icon btn btn-actions" :src="removeIcon" @click="confirmCompanyRemoval(data.item)" />
              </div>
            </template>
            <template v-slot:table-busy>
              <div class="text-center">
                <b-spinner class="align-middle" />
                <strong>Loading...</strong>
              </div>
            </template>
          </data-table>
        </div> -->
        <div class="col-12 mb-4">
          <GridTable
            :get-page="getPage"
            :isLoading="isLoading"
            :columns="columns"
            :perPage="perPage"
            :currentPage="currentPage"
            :onDelete="confirmCompanyRemoval"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { NavigationMixin, CompanyMixin, AuthMixin } from '../../mixins';
import removeIcon from '../../assets/icons/remove.svg';
import warningIcon from '../../assets/icons/warning.svg';
import TableFilter from '../table/table-filter';
import DataTable from '../table/data-table';
import GridTable from '../table/new-data-table';

export default {
  name: 'CompanyList',
  components: { TableFilter, DataTable, GridTable },
  mixins: [NavigationMixin, CompanyMixin, AuthMixin],
  data: function() {
    return {
      table: {
        fields: [
          { key: 'name', label: 'Name' },
          { key: 'contactPersonName', label: 'Kontaktperson' },
          // { key: 'email', label: 'Email' },
          { key: 'companyToken', label: 'Token', thClass: 'token-field' },
          { key: 'createdAt', label: 'Kunde seit' },
          { key: 'actions', label: '', class: 'actions-cell', tdClass: 'w50' }
        ],
        filter: { name: null, companyToken: null },
        sortDesc: true,
        sortBy: 'createdAt'
      },
      columns: [
        { field: 'name', title: 'Name', filterable: true },
        { field: 'contactPersonName', title: 'Kontaktperson', filterable: false },
        { field: 'companyToken', title: 'Token', filterable: true, width: 350 },
        { field: 'createdAt', title: 'Kunde seit', filterable: false, cell: 'dateCell' },
        {
          field: 'actions',
          title: ' ',
          class: 'actions-cell',
          filterable: false,
          sortable: false,
          cell: 'actionCellTemplate',
        }
      ],
      removeIcon: removeIcon,
      isLoading: false,
      perPage: 1000,
      currentPage: 1,
      totalCount: null
    };
  },
  computed: {
    ...mapState({
      isAuthenticated: state => state.auth.isAuthenticated
    })
  },
  methods: {
    async getPage(ctx) {
      this.isLoading = true;
      const response = await this.companyService.getCompanies(ctx);
      this.isLoading = false;
      return { ...response, createdAt: new Date(response.createdAt) };
    },
    async confirmCompanyRemoval(company) {
      const h = this.$createElement;
      const messageVNode = h('div', [
        h('p', [
          h('b-img', {
            class: ['warning-icon'],
            props: {
              src: warningIcon
            }
          })
        ]),
        h('p', [h('strong', 'Möchten Sie wirklich den Kunden löschen?')]),
        h('p', [h('span', company.name)])
      ]);
      const isConfirmed = await this.$bvModal.msgBoxConfirm([messageVNode], {
        centered: true,
        okTitle: 'Löschen',
        cancelTitle: 'Zurück',
        modalClass: 'confirm-modal'
      });
      if (isConfirmed) {
        await this.companyService.removeCompany(company.id);
        return true;
        // this.$refs.table.refresh();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.token-field {
  width: 330px;
}
.btn.btn-primary.btn-new-company {
  font-size: 16px;
  line-height: 19px;
  height: 36px;
  padding: 8px 20px 10px 20px;
}

.actions-cell img {
  margin: 0 !important;
}
</style>
